import { useTypedSelector } from '@k3/core';

export type Dealer =
  | 'DMK'
  | 'hoeffner'
  | 'kraft'
  | 'mahler'
  | 'schrankwerkde'
  | 'scontode';

export const useDealer = (): Dealer => {
  const dealer = useTypedSelector((state) => state.common.dealerData.code);
  return (dealer ?? 'hoeffner') as Dealer;
};
